// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader___-_y5","lds-ring":"Loader_lds-ring__3tRPN"};